<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> کلاس های فوق برنامه  </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <!-- اطلاعات -->

    <div class="border border-2 p-2">

        <!-- جستجو -->

        <div class="row gx-2 gy-md-0 gy-3">

            <!-- جستجو -->

            <div class="col-12 col-md-11">

                <input class="w-100 form-control" placeholder="جستجو کنید ..." (keyup)="filter_list($event.target)">

            </div>

            <!-- افزودن -->

            <div class="col-12 col-md-1">

                <button class="btn btn-success w-100" (click)="add_Request()"> 

                    افزودن
                    
                </button>

            </div>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 150px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>
            
                    <tr class="">
        
                        <th class="col-1 text-center"> # </th>
    
                        <th class="col-2 text-center"> عملیات </th>

                        <th class="text-center"> عنوان </th>

                    </tr>
                    
                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Result;let i = index">

                        <th class="col-1"> {{ i + 1 | faNum }} </th>

                        <th class="col-2"> 

                            <i class="fa fa-user-circle-o me-2 fa-lg pointer" aria-hidden="true" (click)="addStudent(item)"></i>

                            <i class="fa fa-pencil-square me-2 fa-lg pointer" aria-hidden="true" (click)="add_Request(item,i)"></i>

                            <i class="fa fa-trash me-2 fa-lg pointer" aria-hidden="true" (click)="remove_class(item,i)"></i>

                        </th>

                        <td>{{ item.strTitle | faNum}}</td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

    <!-- مدال افزودن, ویرایش -->

    <div class="modal fade" id="Add_ExtraClass" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

        <div class="modal-dialog modal-md">
    
            <div class="modal-content dirI">
    
                <div class="modal-header dirI">
    
                    <h5 class="modal-title" id="exampleModalLabel"> {{  bEditMode ? 'ویرایش' : 'افزودن' }} کلاس فوق برنامه </h5>
    
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    
                </div>
    
                <div class="modal-body">

                    <div [formGroup]="mdl_Request" class="container-fluid row gx-2 gy-2 p-2">

                        <!-- عنوان -->

                        <div class="position-relative col-12 p-2">

                            <label class="mb-2 text-muted"> عنوان </label>
                
                            <input class="form-control p-2 text-center" formControlName="strTitle">
                
                        </div>

                    </div>
    
                </div>
    
                <div class="modal-footer d-flex justify-content-start">

                    <button class="btn"  [ngClass]="bEditMode ? 'btn-primary' : 'btn-success'" (click)="submit_superClass()">
    
                        &nbsp; {{  bEditMode ? 'ویرایش' : 'افزودن' }} &nbsp;
    
                    </button>

                    <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
    
                        &nbsp; بستن &nbsp;
    
                    </button>
    
                </div>
    
            </div>
    
        </div>
    
    </div>

    <!-- مدال افزودن, ویرایش -->

    <div class="modal fade" id="Add_Student" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

        <div class="modal-dialog modal-lg">
    
            <div class="modal-content dirI">
    
                <div class="modal-header dirI">
    
                    <h5 class="modal-title" id="exampleModalLabel"> دانش آموزان </h5>
    
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    
                </div>
    
                <div class="modal-body">

                    <div class="row gx-2 gy-2 p-2">

                        <!-- جستجو -->

                        <div class="col-8">

                            <div class="w-100 py-2">

                                <input type="text" class="w-100 form-control" placeholder="جستجو کنید ...."  (keyup)="filter_Student($event.target)">

                            </div>

                        </div>

                        <!-- انتخاب همه -->

                        <div class="col-2">

                            <div class="w-100 py-2">

                                <button class="w-100 btn btn-success"  (click)="addOrRemove_Student(true)"> 

                                    انتخاب همه
                                    
                                </button>

                            </div>

                        </div>

                        <!-- حذف -->

                        <div class="col-2">

                            <div class="w-100 py-2">

                                <button class="w-100 btn btn-danger"  (click)="addOrRemove_Student(false)"> 

                                    حذف همه
                                    
                                </button>

                            </div>

                        </div>

                        <!-- دانش آموزان -->

                        <div class="col-12 section border border-2 mt-2" style="height:calc(100vh - 330px);overflow: auto;">

                            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                                <thead>
                            
                                    <tr class="">
                        
                                        <th class="col-1 text-center"> # </th>

                                        <th class="col-1 text-center pointer" (click)="selectAll()"> انتخاب </th>
                    
                                        <th class="col-2 text-center"> نام، نام خانوادگی </th>
                                        
                                        <th class="col-2 text-center"> مدرسه </th>
                                        
                                        <th class="col-1 text-center"> پایه </th>

                                        <th class="col-1 text-center"> کلاس </th>

                                    </tr>
                                    
                                </thead>

                                <tbody>

                                    <tr class="col-12 text-center" *ngFor="let item of lst_Student;let i = index">

                                        <th class="col-1"> {{ i + 1 | faNum }} </th>

                                        <td class="col-1"> 

                                            <input type="checkbox" class="pointer" [checked]="item.bSelected" (change)="setCheckBox($event.target.checked,item,i)">
                                            
                                        </td>

                                        <td class="col-2">{{ item.strPassenger_FullName | faNum}} </td>

                                        <td class="col-2">{{ item.strMobileDomain_strComment | faNum}} </td>

                                        <td class="col-1">{{ item.strGrade | faNum}} </td>

                                        <td class="col-1">{{ item.strClassNo_strTitle | faNum}} </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>


                    </div>
    
                </div>
    
                <div class="modal-footer d-flex justify-content-start">

                    <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
    
                        &nbsp; بستن &nbsp;
    
                    </button>
    
                </div>
    
            </div>
    
        </div>
    
    </div>

</main>